import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { brandAlt, background } from '@guardian/src-foundations/palette';
import { headline, textSans } from '@guardian/src-foundations/typography';
import { space } from '@guardian/src-foundations';
import { until } from '@guardian/src-foundations/mq';
import { Score } from '@frontend/web/components/Score';
const Row = ({ children }) => (_jsx("div", Object.assign({ css: css `
			display: flex;
			flex-direction: row;
		` }, { children: children }), void 0));
const CrestRow = ({ children }) => (_jsx("div", Object.assign({ css: css `
			display: flex;
			flex-direction: row;
			align-items: flex-end;
		` }, { children: children }), void 0));
const StretchBackground = ({ children }) => (_jsx("div", Object.assign({ css: css `
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			position: relative;
			padding: ${space[2]}px;
			background-color: ${brandAlt[400]};
			margin-bottom: 10px;
			${until.tablet} {
				margin: 0 -10px 10px;
			}

			:before {
				content: '';
				position: absolute;
				top: 0;
				bottom: 0;
				width: 100vw;
				left: -100vw;
				background-color: ${brandAlt[400]};
				z-index: -1;
			}
		` }, { children: children }), void 0));
const Column = ({ children }) => (_jsx("div", Object.assign({ css: css `
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		` }, { children: children }), void 0));
const TeamName = ({ name }) => (_jsx("h2", Object.assign({ css: css `
			${headline.xxsmall({ fontWeight: 'bold' })}
		` }, { children: name }), void 0));
const Scorers = ({ scorers }) => (_jsx("ul", Object.assign({ css: css `
			margin-top: ${space[1]}px;
			margin-bottom: ${space[3]}px;
		` }, { children: scorers.map((player) => (_jsx("li", Object.assign({ css: css `
					${textSans.small()}
				` }, { children: player }), void 0))) }), void 0));
const Crest = ({ crest }) => (_jsx("div", Object.assign({ css: css `
			position: relative;
			width: 3.75rem;
			height: 3.75rem;
			border-radius: 1.875rem;
			background-color: ${background.primary};
			z-index: 1;
		` }, { children: _jsx("img", { css: css `
				position: absolute;
				left: 0.5rem;
				right: 0.5rem;
				bottom: 0.5rem;
				top: 0.5rem;
				max-width: calc(100% - 1rem);
				max-height: calc(100% - 1rem);
				margin: auto;
				display: block;
			`, src: crest, alt: "" }, void 0) }), void 0));
const TeamNav = ({ name, score, crest, scorers, }) => (_jsx("div", Object.assign({ css: css `
			display: flex;
			flex-grow: 1;
			flex-basis: 50%;
		` }, { children: _jsxs(Column, { children: [_jsxs("div", Object.assign({ css: css `
					display: flex;
					flex-direction: column;
					flex-grow: 1;
				` }, { children: [_jsx(TeamName, { name: name }, void 0), _jsx(Scorers, { scorers: scorers }, void 0)] }), void 0), _jsxs(CrestRow, { children: [_jsx(Crest, { crest: crest }, void 0), _jsx("div", Object.assign({ css: css `
						margin-left: -${space[2]}px;
					` }, { children: _jsx(Score, { score: score }, void 0) }), void 0)] }, void 0)] }, void 0) }), void 0));
const Comments = ({ comments }) => (_jsx("div", Object.assign({ css: css `
			${textSans.small()}
			margin-top: ${space[2]}px;
			padding-top: ${space[1]}px;
			font-style: italic;
			/* stylelint-disable-next-line color-no-hex */
			border-top: 1px solid #d0bb04;
		` }, { children: comments }), void 0));
const YellowBorder = () => (_jsx("div", { css: css `
			/* stylelint-disable-next-line color-no-hex */
			border-left: 1px solid #d0bb04;
			margin-left: ${space[1]}px;
			width: ${space[2]}px;
		` }, void 0));
export const MatchNav = ({ homeTeam, awayTeam, comments }) => (_jsx("div", { children: _jsxs(StretchBackground, { children: [_jsxs(Row, { children: [_jsx(TeamNav, { name: homeTeam.name, score: homeTeam.score, crest: homeTeam.crest, scorers: homeTeam.scorers }, void 0), _jsx(YellowBorder, {}, void 0), _jsx(TeamNav, { name: awayTeam.name, score: awayTeam.score, crest: awayTeam.crest, scorers: awayTeam.scorers }, void 0)] }, void 0), comments && _jsx(Comments, { comments: comments }, void 0)] }, void 0) }, void 0));
